import { THEME_BREAKPOINTS as breakpoints } from './breakpoints';
import { THEME_COLORS as colors } from './colors';
import { THEME_ICONS as icons } from './icons';
import { THEME_TYPOGRAPHY as typography } from './typography';

/**
 * @name THEME
 * @description default theme
 */
export const THEME = {
  breakpoints,
  colors,
  icons,
  typography,
};
